import install from './install.js'
export default {
  install
}
